import { Component, inject, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RootState } from '../../core/state/shared/root-state.interface';
import { filter, Observable, take } from 'rxjs';
import { ProductModel } from '../../core/models/user-profile.model';
import {
  selectSuccessMessage,
  selectProductsPairings,
} from '../../core/state/user-session/user-session.selectors';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BannerComponent } from '../../components/banner/banner.component';
import { MatIcon } from '@angular/material/icon';
import { ProductSectionComponent } from '../../components/product-section/product-section.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    HeaderComponent,
    BannerComponent,
    MatIcon,
    ProductSectionComponent,
    AsyncPipe,
    TranslateModule,
  ],
})
export class HomeComponent implements OnInit {
  products$: Observable<Record<string, ProductModel[]>>;

  private store = inject(Store<RootState>);
  private snackBar = inject(MatSnackBar);

  ngOnInit() {
    this.products$ = this.store.pipe(select(selectProductsPairings));
    this.store
      .select(selectSuccessMessage)
      .pipe(
        filter((key) => !!key),
        take(1),
      )
      .subscribe((key) => {
        this.openSuccessSnackbar(key);
      });
  }

  openSuccessSnackbar(key) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        messageKey: key,
        iconKey: 'check_circle',
      },
      duration: 5000,
      panelClass: 'success-snackbar',
    });
  }
}
